module.exports = __webpack_public_path__ + "media/images/flags/64/Syria-7e6781aaf283f92a23684f73c11a3e33.png";